import { createSlice } from "@reduxjs/toolkit";

const initialState = { matchFeed: {} };

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearDashboard(state) {
      state.matchFeed = {};
    },
    // setInitialFeed(state, action) {
    //   state.matchFeed = action.payload;
    // },
    setInitialFeed(state, action) {
      const incoming = action.payload;

      Object.keys(incoming).forEach((marketId) => {
        if (!state.matchFeed[marketId]) {
          // Only set if not already in store (preserve existing odds)
          state.matchFeed[marketId] = incoming[marketId];
        }
      });

      // Remove stale markets no longer in the feed
      Object.keys(state.matchFeed).forEach((marketId) => {
        if (!incoming[marketId]) {
          delete state.matchFeed[marketId];
        }
      });
    },
    updateMatchFeed(state, action) {
      const { marketId, updated } = action.payload;

      state.matchFeed[marketId] = {
        ...state.matchFeed[marketId],
        ...updated,
      };
    },
  },
});

export const dashboardActions = dashboardSlice.actions;
export default dashboardSlice;
